import { render, staticRenderFns } from "./CertificatesPanel.vue?vue&type=template&id=6bf2d10f&scoped=true"
import script from "./CertificatesPanel.vue?vue&type=script&lang=js"
export * from "./CertificatesPanel.vue?vue&type=script&lang=js"
import style0 from "./CertificatesPanel.vue?vue&type=style&index=0&id=6bf2d10f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2d10f",
  null
  
)

export default component.exports